import { Controller } from "@hotwired/stimulus"

// Toggles forum category block collapsed/expanded state on index page
export default class extends Controller {
  connect() {
    this.block = this.element.closest(".forum-category-block")
  }

  toggle() {
    if (!this.block) return
    this.block.classList.toggle("forum-category-collapsed")
    const expanded = !this.block.classList.contains("forum-category-collapsed")
    this.element.setAttribute("aria-expanded", expanded)
  }
}
